import { useUserData as useUserDataFromApi } from '@/src/infrastructure/services/useUserData';

import { useUserDataWithPostMessage } from './useUserDataWithPostMessage';
import { useWithCompat } from './useWithCompat';

export const useUserData = () => {
  return useWithCompat(useUserDataFromApi, useUserDataWithPostMessage);
};
